/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function proPageSliders() {
  var collageGrid = document.querySelector('.proPro__collageGrid');
  var qaGrid = document.querySelector('.proPro__qaGrid');
  var collageFlkty = null;
  var qaFlkty = null;
  var mobileQuery = window.matchMedia('(max-width: 959px)');

  function initSliders() {
    if (mobileQuery.matches) {
      if (collageGrid && !collageFlkty) {
        collageFlkty = new Flickity(collageGrid, {
          cellAlign: 'center',
          contain: true,
          prevNextButtons: false,
          pageDots: true,
          wrapAround: false,
          adaptiveHeight: true,
        });
      }
      if (qaGrid && !qaFlkty) {
        qaFlkty = new Flickity(qaGrid, {
          cellAlign: 'left',
          contain: true,
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
          adaptiveHeight: true,
          on: {
            ready: function () {
              setTimeout(function () { qaFlkty.resize(); }, 500);
            }
          }
        });
      }
    } else {
      if (collageFlkty) {
        collageFlkty.destroy();
        collageFlkty = null;
      }
      if (qaFlkty) {
        qaFlkty.destroy();
        qaFlkty = null;
      }
    }
  }

  initSliders();
  mobileQuery.addEventListener('change', initSliders);
}

